export const fontSize = {
  9: `56.25%`, // 0.56rem   || 9px
  10: `62.50%`, // 0.65rem   || 10px
  11: `68.75%`, // 0.7rem   || 11px
  12: `75.00%`, // 0.8rem   || 12px
  13: `81.25%`, // 0.84.5rem   || 13px
  14: `87.50%`, // 0.87rem  || 14px
  15: `93.75%`, // 0.9rem  || 15px
  16: `100%`, // 1rem  || 16px
  18: `112.5%`, // 1.125rem  || 18px
  20: `125.00%`, // 1.25rem  || 20px
  22: `137.5%`,
  37: `231.25%`, // 1.3rem  || 37px
};
